/**
 * Yvine Design — collection page (in-place filter pills, pagination, sort).
 * Cached asset, initialised once per [data-art="collection"] element by art-core.js
 * (first paint, every in-place page swap, theme-editor reloads).
 */
Art.section('collection', function (root) {
  // Bands on the shop landing use the shared ArtStrip, exactly as the Gallery
  // does — layout, arrows, dragging and the idle drift.
  if (window.ArtStrip) window.ArtStrip.init(root);
  else document.addEventListener('DOMContentLoaded', function () {
    if (window.ArtStrip) window.ArtStrip.init(root);
  });

    var section = root;
    if (!window.history || !window.DOMParser) return;

    var results = section.querySelector('[data-results]');
    if (!results) return; // shop closed (theme setting): nothing to swap
    var pills = section.querySelector('[data-pills]');
    var head = section.querySelector('[data-head]');
    var inflight;

    function reveal(scope) {
      // Newly injected cards: show immediately (no fade-in flash on swap).
      (scope || section).querySelectorAll('.scroll-reveal').forEach(function (el) {
        el.classList.add('is-visible');
      });
      // Let art-card.js bind hover-video on the new cards.
      document.dispatchEvent(new Event('shopify:section:load'));
    }

    function swap(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newResults = doc.querySelector('[data-results]');
      var newPills = doc.querySelector('[data-pills]');
      var newHead = doc.querySelector('[data-head]');
      if (newResults) results.innerHTML = newResults.innerHTML;
      if (newPills && pills) pills.innerHTML = newPills.innerHTML;
      if (newHead && head) head.innerHTML = newHead.innerHTML;
      var t = doc.querySelector('title');
      if (t) document.title = t.textContent;
      reveal(results);
    }

    // Pills, pages and sort fade like a page change (Art.fade): out while the
    // next results are fetched, swapped while invisible, back in. A new page
    // of results starts at the top; a pill or a sort keeps the reader's place.
    // The site loader shows only if the fetch outlasts the fade by 350ms.
    var loader = document.querySelector('.art-loader--page');
    var loaderTimer = null;
    function load(url, push, toTop) {
      if (inflight) { try { inflight.abort(); } catch (e) {} }
      var ac = new AbortController();
      inflight = ac;
      window.clearTimeout(loaderTimer);
      var myTimer = loaderTimer = window.setTimeout(function () { if (loader) loader.hidden = false; }, 570);
      function done() {
        // Only the latest load owns the loader; an aborted one just leaves.
        if (inflight !== ac) return;
        window.clearTimeout(myTimer);
        if (loader) loader.hidden = true;
        inflight = null;
      }
      function get() {
        return fetch(url, { signal: ac.signal, headers: { 'X-Requested-With': 'fetch' } })
          .then(function (r) { return r.text(); });
      }
      function put(html) {
        swap(html);
        if (push) history.pushState({ artColl: true }, '', url);
      }
      var fading = [head, pills, results].filter(Boolean);
      var run = window.Art && window.Art.fade
        ? window.Art.fade(fading, put, { fetch: get, toTop: toTop })
        : get().then(put);
      run.then(done, function () {
        done();
        if (!ac.signal.aborted) window.location.href = url;
      });
    }

    section.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest('a.art-coll__pill, a.art-coll__page');
      if (!a || !section.contains(a)) return;
      var url = a.getAttribute('href');
      if (!url || url.charAt(0) === '#') return;
      e.preventDefault();
      load(url, true, a.classList.contains('art-coll__page'));
    });

    // Sort dropdown: rebuild the URL with the chosen sort_by and swap in place.
    section.addEventListener('change', function (e) {
      var sel = e.target.closest('select[data-sort]');
      if (!sel) return;
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page'); // back to first page when re-sorting
      load(url.pathname + url.search, true);
    });

    // NOTE: this is on window, so it outlives its own markup. Every in-place
    // visit to the Shop leaves another one bound, and `load()` falls back to a
    // HARD navigation to a collection URL when its fetch does not come back —
    // so a stale one answering a Back press on some other page sends you to a
    // collection you never asked for. It retires itself once its section has
    // been swapped out.
    window.addEventListener('popstate', function onPop(e) {
      if (!document.contains(section)) { window.removeEventListener('popstate', onPop); return; }
      if (e.state && e.state.artColl) load(location.href, false);
    });
});
